import { useState, useEffect } from "react";
import type {
  SeveridadeFiltro,
  CategoriaFiltro,
  StatusFiltro,
} from "../../../types/api";
import { chamadosService } from "../../../lib/api";

interface FilterOptions {
  severidades: SeveridadeFiltro[];
  categorias: CategoriaFiltro[];
  status: StatusFiltro[];
}

export const useFilterOptions = () => {
  const [options, setOptions] = useState<FilterOptions>({
    severidades: [],
    categorias: [],
    status: [],
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const [severidades, categorias, status] = await Promise.all([
          chamadosService.getSeveridades(),
          chamadosService.getCategorias(),
          chamadosService.getStatus(),
        ]);

        setOptions({
          severidades,
          categorias,
          status,
        });
      } catch (err) {
        console.error("Erro ao carregar opções de filtro:", err);
        setError("Erro ao carregar opções de filtro");
      } finally {
        setIsLoading(false);
      }
    };

    fetchFilterOptions();
  }, []);

  return { options, isLoading, error };
};
